module.exports = __webpack_public_path__ + "static/media/the-dutch_shot-shot-shot.66aac8e5.jpg";